/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useContext, useEffect, useRef, useState } from 'react'

import { UserContext } from '../../store/user-context-provider'
import ActionButtons from '../buttons/action-buttons'
import './helpdesk.css'

let popupTop: number
let xpositionvalue: any
let offsetLeftValue: number
let offsetTopValue: number
let elementHeightValue: number
let offsetWidthValue: number

const Helpdesk = () => {
  function onChangeInputSelect(value: any) {  return }
  /** *** Responsive Popup Code Start*****/
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)
  const helpdesk = useRef(null)
  const popupbtnRef = useRef(null)
  const [xpositionvalueupdate, setpopupwidthupdate] = useState('')
  const [popupheight, setpopupheight] = useState<any>()
  const [showActionPopups, setShowActionPopups] = useState({
    helpdesk: false,
  })
  const [btnActionshowhide, setActionbtnshowhide] = useState({
    helpdesk: false,
  })
  useEffect(() => {
    setpopupheight(window.innerHeight - (offsetTopValue + 90))
    const popupwidthdata = popupbtnRef.current
      ? popupbtnRef.current.offsetWidth
      : 0
    // setpopupwidth(popupwidthdata)
    if (popupwidthdata < xpositionvalue) {
      xpositionvalue = xpositionvalue - popupwidthdata
      setpopupwidthupdate(xpositionvalue)
    } else if (
      popupwidthdata > offsetLeftValue &&
      popupwidthdata < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xpositionvalue = offsetLeftValue
      setpopupwidthupdate(xpositionvalue)
    } else if (
      popupwidthdata > offsetLeftValue &&
      popupwidthdata > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xpositionvalue = 0
      setpopupwidthupdate(xpositionvalue)
    }
  }, [multiplePopup])
  const showhide = { ...btnActionshowhide }
  function popupCloseOpenFunctionality(
    type: any,
    value: number,
    top: number,
    xposition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    popupTop = top
    xpositionvalue = xposition
    offsetLeftValue = left
    offsetTopValue = top
    elementHeightValue = elementHeight
    offsetWidthValue = offsetWidth
    showhide.helpdesk = false
    setActionbtnshowhide(showhide)
    if (type === multiplePopup) {
      setMultiplePopup()
    } else if (type) {
      setMultiplePopup(type)
    }
  }
  return (
    <div className='helpdesk p-relative'>
      <ActionButtons
        className={
          multiplePopup === 'helpdesk'
            ? 'p-relative popup-arrow bordered17 btn-md font-0 font-lg-13 poppins-medium btn-border-radius3 p-relative text-uppercase mx-2 active btn-hover px-3'
            : 'bordered17 btn-md font-0 font-lg-13 poppins-medium btn-border-radius3 p-relative text-uppercase mx-2 px-3 btn-hover'
        }
        icon='icon-tophelpdesk font-18 me-md-1'
        isClick='helpdesk'
        label='Help Desk'
        name='Help Desk'
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}  
        ref={helpdesk}
        showHide={showActionPopups.helpdesk}
        type='button'
      />
      {multiplePopup === 'helpdesk' ? (
        <div
          className='popup p-0'
          ref={popupbtnRef}
          style={{
            maxHeight: popupheight,
            overflow: 'auto',
            position: 'absolute',
            top: popupTop + 8,
          }}
        >
          <div className='d-flex w-100 p-relative align-items-center border-bottom1 py-2 px-3'>
            <h2
              aria-label='Help desk'
              className='d-flex align-items-center font-12 text-uppercase Poppins-medium title-color49 '
              tabIndex={0}
            >
              <span className='icon-tophelpdesk font-18 pe-1 title-color48'></span> Help desk
            </h2>

            <div className='close'>
              <ActionButtons
                className='my-0 btn font-0'
                icon='icon-close font-10 p-1 color-primary '
                isClick='helpdesk'
                label='close'
                name=''
                popupCloseOpenFunctionality={popupCloseOpenFunctionality}
                ref={helpdesk}
                showHide={showActionPopups.helpdesk}
                type='button'
              />
            </div>
          </div>

          <div className='p-2'>
            <div aria-describedby='helpdesk-timings' className='d-flex align-items-center' id='helpdesk-timings' tabIndex={0} >
              <div className='icon-hours me-1 color-primary '></div>
              <div className='d-flex poppins-medium font-12 '><p className='color-primary '>Hours of operation:</p>
                <p className='title-color2 px-1'>9 AM to 6 PM  </p></div>
            </div>
            <p className='d-flex align-items-center pt-2 poppins-medium font-12'>
              <span className='icon-mail me-1 color-primary '></span>
              <a className='links' href='mailto:scott.rowell@us.af.mil' title='scott.rowell@us.af.mil'  >scott.rowell@us.af.mil</a>
            </p>
            <p className='d-flex align-items-center pt-2 poppins-medium font-12'>
              <span className='icon-phone me-1 color-primary '></span>
              <a className='color-primary' href='tel:(123) 456-7890' title='(123) 456-7890' >(123)555-6789</a>
            </p>

          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
export default Helpdesk
